import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=5be8f13a&scoped=true"
import script from "./customInput.vue?vue&type=script&lang=js"
export * from "./customInput.vue?vue&type=script&lang=js"
import style0 from "./customInput.vue?vue&type=style&index=0&id=5be8f13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8f13a",
  null
  
)

export default component.exports